import { Button, Flex, Table } from "antd";
import { SearchOutlined, CloseCircleOutlined } from "@ant-design/icons";
import styles from "../equipmentPartListPopup.module.css";
import tool from "../../../assets/icons/tool.svg";
import aperture from "../../../assets/icons/aperture.svg";
import location from "../../../assets/icons/location1.svg";
import { useEffect, useState } from "react";
import { FetchAssetEquipmentAndPart } from "../../../redux/actions/action";
import { useDispatch, useSelector } from "react-redux";

function EquipmentsPartsModal({
  assetList,
  setAssetList,
  modalOpen,
  modalHideEv,
  supplierId,
  locationSupplierID,
}) {
  const dispatch = useDispatch();
  const [searchItems, setSearchItems] = useState("");
  const [stockData, setStockData] = useState([]);
  const [selectEquipment, setSelectEquipment] = useState(null);

  useEffect(() => {
    if (supplierId || locationSupplierID) {
      dispatch(
        FetchAssetEquipmentAndPart(supplierId ? supplierId : locationSupplierID)
      );
    }
  }, [dispatch]);

  const fetchEquipmentAndPartList = useSelector(
    (state) => state.user.fetchEquipmentAndPart
  );

  useEffect(() => {
    if (fetchEquipmentAndPartList.status === true) {
      setStockData(fetchEquipmentAndPartList?.data);
    }
  }, [fetchEquipmentAndPartList]);

  const handleCheckboxChange = (e, record) => {
    // const isChecked = e.target.checked;
    const isChecked =
      e.target.type === "checkbox" ? e.target.checked : !record.isChecked;

    if (isChecked) {
      // Unselect the previously selected equipment
      if (selectEquipment !== null) {
        const prevCheckbox = document.getElementById(
          `checkbox_${selectEquipment}`
        );
        if (prevCheckbox) {
          prevCheckbox.checked = false;
        }
      }
      setSelectEquipment(record.assetid);
    }

    // Update isChecked property for the clicked row
    const updatedData = stockData.map((item) =>
      item.assetid === record.assetid ? { ...item, isChecked } : item
    );
    setStockData(updatedData);
  };

  const partTableColumn = [
    {
      title: "",
      dataIndex: "assetid",
      key: "assetid",
      render: (text, record) => (
        <div className="custom-checkbox-wrap">
          <input
            type="checkbox"
            checked={record.isChecked}
            id={`checkbox_${record.assetid}`}
            onChange={(e) => handleCheckboxChange(e, record)}
          />
          <span className="checkmark"></span>
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "assetname",
      key: "assetname",
      render: (text, record) => (
        <div
          className={styles.icon_text}
          style={{ cursor: "pointer" }}
          onClick={(e) => handleCheckboxChange(e, record)}
        >
          <div className={styles.icon_wrap}>
            <img src={getImageSource(record.assetTypeName)} alt="part icon" />
          </div>
          {text}
        </div>
      ),
    },
    {
      title: "",
      dataIndex: "assetDescription",
      key: "assetDescription",
      render: (text, record) => <div className={styles.icon_text}>{text}</div>,
    },
  ];

  const getImageSource = (type) => {
    switch (type) {
      case "Equipment":
        return aperture;
      case "Part":
        return tool;
      case "Facility":
        return location;
      // Add more cases as needed
    }
  };

  const handleSearchInputChange = (e) => {
    setSearchItems(e.target.value);
    searchItemFun();
  };
  const searchItemFun = () => {
    const result = stockData.filter((item) =>
      item.productPartName.toLowerCase().includes(searchItems.toLowerCase())
    );
    setStockData(result);
  };
  const AddMissingItems = () => {
    const selectedRows = stockData.filter((val) => val.isChecked);

    // Check if each selected item is not already in the assetList
    selectedRows.forEach((selectedRow) => {
      const isAlreadyAdded = assetList.some(
        (item) => item.assetid === selectedRow.assetid
      );

      // If the item is not already in the assetList, add it
      if (!isAlreadyAdded) {
        const updatedItem = {
          ...selectedRow,
          productid: selectedRow.assetid,
          quantity: 0,
          total: 0,
          requestedDeliverDays: 1,
        };

        setAssetList((prevDataList) => [...prevDataList, updatedItem]);
      }
    });

    // Close the modal
    modalHideEv(!modalOpen);
  };

  const [equipmentAndPartSearch, setEquipmentAndPartSearch] = useState("");

  return (
    <>
      <div
        className={`${styles.addPartPopupAsset} ${
          modalOpen ? styles.show : ""
        }`}
      >
        <div className={styles.part_popup_inner}>
          <div className={styles.part_popup_header}>
            <div className={styles.title_wrap}>
              <Flex gap="small" className={styles.flex}>
                <h2>Equipments & Parts</h2>
                <div className={styles.list_toggle_btn}>
                  <div className={styles.btn_wrap}>
                    <button type="button" className={styles.active_btn}>
                      List
                    </button>
                    <button type="button">Tree</button>
                  </div>
                </div>
                <div className={styles.search_input}>
                  <input
                    type="text"
                    placeholder="Search"
                    value={equipmentAndPartSearch}
                    onChange={(e) => {
                      setEquipmentAndPartSearch(e.target.value);
                    }}
                  />
                  <Button
                    type="text"
                    shape="circle"
                    icon={<SearchOutlined />}
                  />
                </div>
              </Flex>
            </div>
            <div className={styles.close_btn_wrap}>
              <Button
                type="text"
                shape="circle"
                icon={<CloseCircleOutlined />}
                onClick={AddMissingItems}
              />
            </div>
          </div>
          <div className={styles.popup_body}>
            <div className={`${styles.table_wrapper} part-table-wrapper`}>
              <Table
                columns={partTableColumn}
                dataSource={stockData.filter((item) =>
                  item?.assetname
                    .toLowerCase()
                    .includes(equipmentAndPartSearch.toLowerCase())
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

// export default connect(mapStateToProps, mapDispatchToProps)(GroupListPopup);
export default EquipmentsPartsModal;
